//import { uuidv4 } from "@antv/xflow-core";
//import FC from "react";
import "./common.scss";

const Pentagon = (props: any) => {
  let id = Date.now() + "-" + Math.random();
  return(  
    <>
  <svg
    width="100"
    height="100"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <linearGradient id={id} x1="0.5" y1="1" x2="0.5" y2="0">
      <stop offset="0%" stop-opacity="1" stop-color="#6284D9" />
      <stop
        offset={`${props?.value}%`}
        stop-opacity="1"
        stop-color="#6284D9"
      >
        <animate
          attributeName="offset"
          values="0;1;0"
          repeatCount="2"
          dur="5s"
          begin="0s"
        />
      </stop>
      <stop
        offset={`${props?.value}%`}
        stop-opacity="0.5"
        stop-color="#F4F5F7"
      >
        <animate
          attributeName="offset"
          values="0;1;0"
          repeatCount="2"
          dur="5s"
          begin="0s"
        />
      </stop>
      <stop offset="100%" stop-opacity="0.5" stop-color="#F4F5F7" />
    </linearGradient>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.0995 4.60318C37.2172 3.73384 38.7823 3.73384 39.9 4.60318L67.7572 26.2698C68.5111 26.8563 68.9521 27.7579 68.9521 28.7131V62.7607C68.9521 65.2234 67.9738 67.5853 66.2324 69.3267C64.491 71.0681 62.1291 72.0464 59.6664 72.0464H16.3331C13.8703 72.0464 11.5085 71.0681 9.76709 69.3267C8.02568 67.5853 7.04736 65.2234 7.04736 62.7607V28.7131C7.04736 27.7579 7.48835 26.8563 8.24231 26.2698L36.0995 4.60318ZM13.2378 30.2269V62.7607C13.2378 63.5816 13.5639 64.3689 14.1444 64.9494C14.7249 65.5298 15.5122 65.8559 16.3331 65.8559H59.6664C60.4873 65.8559 61.2746 65.5298 61.8551 64.9494C62.4355 64.3689 62.7617 63.5816 62.7617 62.7607V30.2269L37.9997 10.9676L13.2378 30.2269Z"
      fill={`url(#${id})`}
    />
  </svg>
  <span
        className="pentagon"
      >
        {`${props?.value}%`}
      </span>
</>
  );
};

export default Pentagon;
